import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { type GetProductListRequestDto } from "../../dtos/get-product-list-request-dto";
import type { GetProductListResponseDto } from "../../dtos/get-product-list-response-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetProductsQueryProps = {
  queryParams: GetProductListRequestDto;
  options?: Omit<UseQueryOptions<GetProductListResponseDto>, "queryKey">;
};

export const useGetProductListQuery = ({
  queryParams,
  options
}: UseGetProductsQueryProps) => {
  return useQuery({
    queryKey: ProductQueryKeys.getProductList({ ...queryParams }).queryKey,
    queryFn: async () =>
      await ProductService.getProductList({ payload: queryParams }),
    ...options
  });
};
